export function uniqueElement(array, key) {
	return array.reduce((accum, element) => {
		if (!accum.find(e => e[key] === element[key])) {
			accum.push(element);
		}

		return accum;
	}, []);
}
